import React from "react";
import PropTypes from "prop-types";
import { Button, Icon } from "@iforwms/react-components";
import FeedbackTag from "../FeedbackTag";
import { Trans } from "@lingui/macro";
import moment from "moment";

function feedbackType(type) {
  var colour = "blue";

  if (type === "CANCELLATION") {
    return "red";
  }

  if (type === "App\\Video") {
    return "orange";
  }

  if (type === "App\\Word") {
    return "pink";
  }

  if (type === "App\\QuizSuggestion") {
    return "green";
  }

  if (type === "App\\QuizQuestion") {
    return "teal";
  }

  if (type === "App\\VideoSentence") {
    return "indigo";
  }

  return colour;
}

const FeedbackRow = ({
  feedback,
  updateFeedbackData,
  updatingFeedback,
  handleUpdateFilter,
  showModal,
  filters,
  updateFeedback,
  showMenu,
  toggleMenu
}) => (
  <div className="flex border-b border-l border-r p-4">
    <div className={`text-${feedback.closed_at ? "red-500" : "teal-500"}`}>
      <Icon icon={feedback.closed_at ? "closedFeedback" : "openFeedback"} />
    </div>
    <div className="w-full">
      <div className="flex mb-2">
        <div className="text-lg mr-2 w-full">
          <div className="mb-2 md:mb-0 flex">
            <span
              className={`inline-block mr-1 p-1 rounded text-xs bg-white border  border-${feedbackType(
                feedback.feedbackable_type
              )}-500 text-${feedbackType(feedback.feedbackable_type)}-500`}>
              {feedback.feedbackable_type
                ? feedback.feedbackable_type.replace("App\\", "")
                : "General"}
            </span>
            <Button
              classes={`text-left`}
              isLink={true}
              colour={`teal`}
              onClick={() => showModal(feedback)}>
              {feedback.time_estimate ? (
                <span className={`inline-block mr-1`}>[{feedback.time_estimate.toFixed(2)}]</span>
              ) : null}
              {feedback.geo_data &&
              feedback.geo_data.location &&
              feedback.geo_data.location.country_flag_emoji ? (
                <span className={`inline-block mr-1`}>
                  {feedback.geo_data.location.country_flag_emoji}
                </span>
              ) : null}
              {feedback.title}
            </Button>

            {feedback.images && feedback.images.length ? (
              <span className="flex items-center ml-2 text-indigo-500">
                <Icon icon="attachment" size={20} />
              </span>
            ) : null}
          </div>

          <div className="flex-wrap flex items-center text-xs -ml-1">
            {filters.map(filter => (
              <FeedbackTag
                toggleMenu={toggleMenu}
                showMenu={showMenu}
                key={filter.column_name}
                filter={filter}
                updateFilter={handleUpdateFilter}
                updateFeedback={updateFeedbackData}
                feedback={feedback}
              />
            ))}

            <div className="ml-auto">
              {feedback.closed_at ? (
                <Button
                  fullWidth={false}
                  disabled={updatingFeedback}
                  onClick={() => updateFeedback(feedback.id, "open")}
                  classes="ml-1 mt-1">
                  <Trans>Re-open</Trans>
                </Button>
              ) : (
                <>
                  <Button
                    fullWidth={false}
                    disabled={updatingFeedback}
                    onClick={() => updateFeedback(feedback.id, "close")}
                    classes="ml-1 mt-1">
                    <Trans>Close</Trans>
                  </Button>

                  <Button
                    fullWidth={false}
                    disabled={updatingFeedback}
                    onClick={() => updateFeedback(feedback.id, "fix")}
                    classes="ml-1 mt-1">
                    <Trans>Fix</Trans>
                  </Button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <div>
        <div className="text-xs text-gray-600 md:mr-2 ">
          #{feedback.id} opened {moment(feedback.created_at).fromNow()}{" "}
          {feedback.email ? (
            <>
              by{" "}
              <Button
                isLink={true}
                classes={`underline`}
                url={`mailto:${feedback.email}?subject=RE: ${feedback.title}`}>
                {feedback.email}
              </Button>
            </>
          ) : (
            " (auto-generated)"
          )}
        </div>
      </div>
    </div>
  </div>
);

FeedbackRow.propTypes = {
  feedback: PropTypes.object.isRequired,
  updateFeedback: PropTypes.func.isRequired,
  updateFeedbackData: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  updatingFeedback: PropTypes.bool.isRequired,
  handleUpdateFilter: PropTypes.func.isRequired,
  queryString: PropTypes.string,
  filters: PropTypes.array.isRequired,
  showMenu: PropTypes.string,
  toggleMenu: PropTypes.func.isRequired
};

export default FeedbackRow;
